module.exports = __webpack_public_path__ + "static/media/bianca_italian.0b4a14c1.mp3";